var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.083 3.66699H3.66634C3.18011 3.66699 2.7138 3.86015 2.36998 4.20396C2.02616 4.54778 1.83301 5.0141 1.83301 5.50033V18.3337C1.83301 18.8199 2.02616 19.2862 2.36998 19.63C2.7138 19.9738 3.18011 20.167 3.66634 20.167H16.4997C16.9859 20.167 17.4522 19.9738 17.796 19.63C18.1399 19.2862 18.333 18.8199 18.333 18.3337V11.917",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.958 2.29122C17.3227 1.92655 17.8173 1.72168 18.333 1.72168C18.8487 1.72168 19.3433 1.92655 19.708 2.29122C20.0727 2.6559 20.2775 3.1505 20.2775 3.66622C20.2775 4.18195 20.0727 4.67655 19.708 5.04122L10.9997 13.7496L7.33301 14.6662L8.24967 10.9996L16.958 2.29122Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditChat);
export default __webpack_public_path__ + "static/media/editChat.0af40135c66788d973e065a1c93ce22a.svg";
export { ForwardRef as ReactComponent };